import { render } from "./ToDoTask.vue?vue&type=template&id=2e41f374&scoped=true"
import script from "./ToDoTask.vue?vue&type=script&lang=js"
export * from "./ToDoTask.vue?vue&type=script&lang=js"

import "./ToDoTask.vue?vue&type=style&index=0&id=2e41f374&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e41f374"]])

export default __exports__